import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('InfoBlock').create(({ theme }) => ({
  root: {
    background: theme.colors.background.secondary,
    display: 'flex',
    padding: '12px 16px',
    gap: '16px',
    position: 'relative',
  },

  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    gap: '4px',
  },

  headingWrapper: {
    display: 'flex',
    gap: '8px',
  },

  heading: {
    display: 'inline-block',
    fontWeight: 350,
    fontSize: theme.sizes.texts.fontSize.m,
    lineHeight: '26px',
    color: theme.colors.text.primary,
  },

  description: {
    fontWeight: 250,
    lineHeight: theme.sizes.texts.lineHeight.s,

    fontSize: '13px',
    color: theme.colors.text.secondary,
  },

  arrowWrapper: {
    position: 'absolute',
    right: '12px',
    display: 'flex',
    alignItems: 'center',
    height: '16px',
    top: '40%',
  },
}))
